import { useRecordContext, useNotify } from "ra-core";
import { Copy } from "lucide-react";
import { formatPhone, phoneHref } from "./phone";
export function PhoneNumber({
  value,
  source,
}: {
  value?: string | null;
  source?: string;
}) {
  const record = useRecordContext();
  const notify = useNotify();
  const number = value ?? (source ? record?.[source] : undefined);
  if (!number) return null;
  return (
    <span className="inline-flex items-center gap-2">
      <a
        href={phoneHref(number)}
        onClick={(event) => event.stopPropagation()}
        className="hover:underline"
        aria-label={`Позвонить ${formatPhone(number)}`}
      >
        {formatPhone(number)}
      </a>
      <button
        data-mobile-control="compact"
        type="button"
        className="inline-flex min-h-8 min-w-8 items-center justify-center"
        aria-label="Скопировать номер телефона"
        onClick={async (event) => {
          event.stopPropagation();
          try {
            await navigator.clipboard.writeText(formatPhone(number));
            notify("Номер скопирован", { type: "success" });
          } catch {
            notify("Не удалось скопировать номер", { type: "error" });
          }
        }}
      >
        <Copy className="size-4" />
      </button>
    </span>
  );
}
